import React from 'react';
import './Header.css';
import Logo from './logo.png';
import {Link} from '@reach/router';

const header =() =>{
    return ( <div>
     
        
  
        <header>
            <Link to ="/">
       <img src={Logo} alt="website logo" class="logo"/>  
       </Link>
      
        <nav>
 
               <ul>
               <li><Link to="/sexuality">Sexuality</Link></li>
                <li><Link to="/gender">Gender</Link></li>
                <li><Link to="/allies">Allies</Link></li>
            </ul>
        </nav> 
        
        </header>
      
        </div>
    )
}

    





export default header;